export default __webpack_public_path__ + "static/media/kb-icon-sg-round.b21665ce.svg";